var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"loading":_vm.loading,"text":"","color":_vm.error ? 'error' : 'primary'},on:{"click":_vm.exportDocx}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-download")]),_vm._v(" Сформировать заявку ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }